// extracted by mini-css-extract-plugin
module.exports = {"txType":"styles_txType__fAzvk","txTypeText":"styles_txTypeText__LLluX"};